import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { Col, Input, Row } from "reactstrap";

const FilterComponent = ({ filters, onFilterChange, setIsSearch }) => {
  const [filterValues, setFilterValues] = useState(
    filters.reduce((acc, filter) => {
      acc[filter.name] = filter.defaultValue || "";
      return acc;
    }, {})
  );

  const debounceTimer = useRef(null);

  const handleChange = (name, value) => {
    const updatedValues = { ...filterValues, [name]: value };
    setFilterValues(updatedValues);
    setIsSearch(false);
    // Clear the previous timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Set a new timer for debouncing (delay of 500ms)
    debounceTimer.current = setTimeout(() => {
      onFilterChange(
        Object.fromEntries(
          Object.entries(updatedValues).filter(([_, val]) => val !== "")
        )
      );
    }, 700); // Adjust delay as needed
  };

  return (
    <Row>
      {filters.map((filter) => (
        <Col sm={12} key={filter.name}>
          <div className="mb-3">
            <label htmlFor={filter.name} className="form-label">
              {filter.label}:
            </label>
            {filter.type === "text" ? (
              <input
                type="text"
                id={filter.name}
                value={filterValues[filter.name]}
                onChange={(e) => handleChange(filter.name, e.target.value)}
                className="form-control"
                placeholder={filter.placeholder || "Select..."}
              />
            ) : filter.type === "number" ? (
              <input
                type="number"
                id={filter.name}
                min={0}
                value={filterValues[filter.name]}
                // onChange={(e) => handleChange(filter.name, e.target.value)}
                onChange={(e) => {
                  let value = e.target.value; // Convert to number or empty string

                  // Convert only "fld_experience" to a number explicitly
                  if (filter.name === "fld_maxexperience") {
                    value = Number(value);
                  }

                  handleChange(filter.name, value);
                }}
                className="form-control"
                placeholder={filter.placeholder || "Select..."}
              />
            ) : filter.type === "range" ? (
              <>
              
                <Input
                  type="range"
                  id={filter.name}
                  // id="exampleRange"
                  name="range"
                  min={0}
                  max={100000}
                  defaultValue={filter.defaultValue}
                  step={1000}
                  value={filterValues[filter.name]}
                  onChange={(e) => {
                    let value = e.target.value; // Convert to number or empty string

                    // Convert only "fld_experience" to a number explicitly
                    if (filter.name === "fld_maxsalary") {
                      value = Number(value);
                    }

                    handleChange(filter.name, value);
                  }}
                  className="form-control"
                  placeholder={filter.placeholder || "Select..."}
                />
                {
                  filterValues[filter.name] && 
                <div className="text-muted">
                  Selected Salary: ₹{filterValues[filter.name] || 0}
                </div>
                }
              </>
            ) : filter.type === "select" ? (
              <Select
                id={filter.name}
                options={filter.options}
                onChange={(selected) =>
                  handleChange(filter.name, selected ? selected.value : "")
                }
                placeholder={filter.placeholder || "Select..."}
                className="form-select"
              />
            ) : null}
          </div>
          
        </Col>
      ))}
    </Row>
  );
};

export default FilterComponent;
